<template>
  <div id="animation" class="animation">
    <img src="../assets/img/logo.svg" alt="" />
  </div>
</template>

<script>
export default {
  name: "BootAnimation",
  mounted() {
    setTimeout(() => {
      this.$router.push({ path: "/webindex" });
    }, 3000);
  }
};
</script>

<style scoped>
.animation {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: url("../assets/img/start/开机banner@2x.jpg") no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-color: #fff;
  align-items: center;
  justify-content: center;
  z-index: 99;
}

.start img {
  width: 120px;
  height: 187.008px;
}
</style>



// WEBPACK FOOTER //
// src/components/BootAnimation.vue